export const GLOBAL_ENV = process.env.GLOBAL_ENV || "staging";
export const SENTRY_DSN = process.env.SENTRY_DSN || "";

export const AUTH_ENDPOINT =
  process.env.AUTH_ENDPOINT || "http://adcontrol.test";
export const API_ENDPOINT =
  process.env.API_ENDPOINT || "http://api.adcontrol.test/v1";

export const AUTH_CLIENT_ID =
  process.env.AUTH_CLIENT_ID || "72DAjRSAIDi2eT4_gYTCX9DmQzaoAONAaQozsyMdAQo";

// ---------------------------------------------------------------------------
// AutomaticReport - hidden from the UI while the remaining ReportTemplate
// features are built (they will change how automatic reports work). The
// feature itself is implemented, frontend and backend; this is only a
// client-side curtain over its entry points, so the API is never called.
//
// NOT a server-driven `FEATURE_*` entitlement: a local, build-time flag.
//
// To un-hide: set to `true`, verify, then delete the flag and inline the
// enabled branch at every call site below.
//
// Call sites (revert all together):
//   src/components/TheTopbar.vue                     -> `settingsVisible` gate on the
//                                                       "Impostazioni" nav link
//   src/router/routes/Settings.ts                    -> exports a redirect-only route
//                                                       instead of the /settings tree
//   src/components/Agencies/CustomReportExporter.vue -> `created()` deep-link guard
//   src/mixins/ReportBuilder/ReportBuilderMixin.ts   -> `visibleTabItems` filter
//   src/mixins/ReportBuilder/
//     AutomaticReportSchedulingMixin.ts              -> `goBackToAutomaticReportsList`
//                                                       fallback
//
// NOTE: the /settings gate closes the whole Settings section, which also holds
// the "Report template" management page. When the ReportTemplate features are
// released, split this flag: keep the automatic-report gates, and restore
// src/router/routes/Settings.ts + the topbar link with the
// "Report automatici" tab removed from views/Settings/index.vue `tabs`.
//
// Deliberately NOT gated (unreachable once the above are off, so they stay
// untouched for a clean revert): views/Settings/**, components/Settings/**,
// the `tabItems` array `visibleTabItems` filters, the models / http mixins /
// store caches.
// ---------------------------------------------------------------------------
export const AUTOMATIC_REPORTS_ENABLED = false;

export const FEATURE_INVESTORS = "investors";
export const FEATURE_ALERTS = "alerts";
export const FEATURE_COMPARISON = "comparison";
export const FEATURE_TIME_SLOTS = "time_slots";
export const FEATURE_CREATIVITY = "creativity";
export const FEATURE_BREAKS = "breaks";

export const FEATURE_AUDITEL = "auditel";
export const FEATURE_AUDITEL_CUSTOM_SORGENIA = "auditel_custom_target_sorgenia";
export const FEATURE_AUDITEL_CUSTOM_KIDS_4_10 =
  "auditel_custom_target_kids_4_10";
export const FEATURE_AUDITEL_CUSTOM_MALE_4_10 =
  "auditel_custom_target_male_4_10";
export const FEATURE_AUDITEL_CUSTOM_FEMALE_4_10 =
  "auditel_custom_target_female_4_10";
export const FEATURE_AUDITEL_CUSTOM_GUESTS_ADULTS_24_54_KIDS_4_14 =
  "auditel_custom_target_guests_adults_25_54_kids_4_14";
export const FEATURE_AUDITEL_CUSTOM_PRIMA_ASSICURAZIONI =
  "auditel_custom_target_prima_assicurazioni";

export const FEATURE_SPECIAL_INITIATIVES_MARKET = "special_initiatives_market";
export const FEATURE_SPECIAL_INITIATIVES_CLIENTS =
  "special_initiatives_clients";
export const FEATURE_SPECIAL_INITIATIVES_TRENDS = "special_initiatives_trends";
export const FEATURE_SPECIAL_INITIATIVES_INVESTORS =
  "special_initiatives_investors";

export const FEATURE_AGENCIES_REPORT = "agencies_report";
export const FEATURE_AGENCIES_TOP_INVESTORS = "agencies_top_investors";
export const FEATURE_AGENCIES_COMPETITORS = "agencies_competitors";

export const FEATURE_AGENTS_PROFILES_ASSOCIATION =
  "agents_profiles_association";
export const FEATURE_AGENTS_PRINCIPALS_MANAGEMENT =
  "agents_principals_management";
export const FEATURE_AGENTS_MODULE = "agents_module";
export const FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH =
  "agents_historic_data_for_agents_match";
export const FEATURE_AGENTS_MATCH_BY_COMPANY = "agents_match_by_company";
export const FEATURE_AGENTS_MATCH_BY_BRAND = "agents_match_by_brand";
export const FEATURE_AGENTS_MATCH_BY_PRODUCT = "agents_match_by_product";
export const FEATURE_AGENTS_MATCH_PROBLEM = "agents_match_problem";
export const FEATURE_AGENTS_MULTIPLE_PRODUCTS = "agents_multiple_products";
export const FEATURE_CURRENCY_UNIT = "ebiquity_currency_unit";

export const FEATURES = [
  FEATURE_INVESTORS,
  FEATURE_ALERTS,
  FEATURE_COMPARISON,
  FEATURE_TIME_SLOTS,
  FEATURE_CREATIVITY,
  FEATURE_BREAKS,
];
export const FEATURES_AUDITEL = [
  FEATURE_AUDITEL,
  FEATURE_AUDITEL_CUSTOM_GUESTS_ADULTS_24_54_KIDS_4_14,
  FEATURE_AUDITEL_CUSTOM_KIDS_4_10,
  FEATURE_AUDITEL_CUSTOM_MALE_4_10,
  FEATURE_AUDITEL_CUSTOM_FEMALE_4_10,
  FEATURE_AUDITEL_CUSTOM_SORGENIA,
  FEATURE_AUDITEL_CUSTOM_PRIMA_ASSICURAZIONI,
];
export const FEATURES_SPECIAL_INITIATIVES = [
  FEATURE_SPECIAL_INITIATIVES_MARKET,
  FEATURE_SPECIAL_INITIATIVES_CLIENTS,
  FEATURE_SPECIAL_INITIATIVES_TRENDS,
  FEATURE_SPECIAL_INITIATIVES_INVESTORS,
];

export const FEATURES_AGENCIES = [
  FEATURE_AGENCIES_COMPETITORS,
  FEATURE_AGENCIES_REPORT,
  FEATURE_AGENCIES_TOP_INVESTORS,
];

export const FEATURES_AGENTS_MODULE = [
  FEATURE_AGENTS_PROFILES_ASSOCIATION,
  FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
  FEATURE_AGENTS_MODULE,
  FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH,
  FEATURE_AGENTS_MATCH_BY_COMPANY,
  FEATURE_AGENTS_MATCH_PROBLEM,
  FEATURE_AGENTS_MATCH_BY_BRAND,
  FEATURE_AGENTS_MULTIPLE_PRODUCTS,
  FEATURE_AGENTS_MATCH_BY_PRODUCT,
];

export const FEATURES_EBIQUITY = [FEATURE_CURRENCY_UNIT];
